import { HomePageNavCards } from 'components';
import styles from './HomePage.module.scss';

export default function HomePage() {

    return(
        <div className={styles.container}>
            <div className={styles.content}>
                <HomePageNavCards />
            </div>
        </div>
    );
}